// app/javascript/packs/routes/Dropzone.jsx

import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import {useDropzone} from 'react-dropzone'
import {COLORS} from "./theme";

const baseStyle = {
  height: "100%",
  border: `2px dashed ${COLORS.primary}`,
  borderRadius: '5px',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const acceptStyle = {borderColor: '#00e676'}
const rejectStyle = {borderColor: '#ff1744'}

function Dropzone(props) {
  const {as, children, style, multiple, ...filteredProps} = props

  const onDrop = useCallback(acceptedFiles => {
    props.onDrop(acceptedFiles[0])
  }, [])

  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject
  } = useDropzone({accept: '.csv, text/csv, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values', onDrop, multiple});
  // useDropzone({accept: '.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values', onDrop});

  const stateStyle = useMemo(() => ({
    ...baseStyle,
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragReject,
    isDragAccept
  ]);

  const finalStyle = {
    ...baseStyle,
    ...style,
    ...stateStyle
  }

  return React.createElement(props.as, {...filteredProps,...getRootProps(), style: finalStyle}, children, <input {...getInputProps()} />)
}

Dropzone.propTypes = {
  as: PropTypes.elementType.isRequired,
  children: PropTypes.node,
  style: PropTypes.object
}

export default Dropzone;
